import { render, staticRenderFns } from "./detailAgingStockTable.vue?vue&type=template&id=b71f1f0c&scoped=true"
import script from "./detailAgingStockTable.vue?vue&type=script&lang=js"
export * from "./detailAgingStockTable.vue?vue&type=script&lang=js"
import style0 from "./detailAgingStockTable.vue?vue&type=style&index=0&id=b71f1f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71f1f0c",
  null
  
)

export default component.exports